import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const Loader = () => (
  <div className="flex min-h-screen items-center justify-center bg-[#080808]" data-testid="page-loader">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#262630] border-t-[#ff3b91]" />
  </div>
);

export const ProtectedRoute = ({ children, admin = false }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};

export const GuestRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
};
